import { render, staticRenderFns } from "./PanelCompetitionForm.vue?vue&type=template&id=28e5945c&scoped=true&"
import script from "./PanelCompetitionForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionForm.vue?vue&type=style&index=0&id=28e5945c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5945c",
  null
  
)

export default component.exports